import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';

import { AlertComponent, DisplayInputComponent } from '@components';
import { Status, VehicleSource } from '@enums';
import { User, Vehicle } from '@models';
import { UtilService } from '@services';
import * as UserActions from '@state/user/user.actions';

@Component({
  selector: 'app-user-vehicle',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatProgressSpinnerModule,
    DisplayInputComponent,
    MatButtonModule,
    MatIconModule,
    AlertComponent,
  ],
  templateUrl: './vehicle.component.html',
  styleUrl: './vehicle.component.scss',
})
export class UserVehicleComponent implements OnChanges {
  @Input() user: User | null = null;
  @Output() setTab: EventEmitter<string> = new EventEmitter<string>();

  public vehicle: Vehicle | undefined;
  public carTrackDriverId: string | undefined;

  public loading: boolean = false;
  public error: string | null = null;

  constructor(private router: Router, public utils: UtilService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.user) {
      this.carTrackDriverId = this.user.carTrackDriverId;
      if (this.user.vehicle) this.vehicle = this.user.vehicle;
    }
  }

  public get isUserVehicle(): boolean {
    return this.vehicle?.source === VehicleSource.USER;
  }

  public onCreateDriverProfileClicked(): void {
    this.setTab.emit('profile');
  }

  public onAssignDriverClicked(): void {
    this.router.navigate(['vehicles']);
  }

  public async onApproveClicked() {
    this.saveProfileStatus(Status.APPROVED);
  }

  public async onDeclineClicked() {
    this.saveProfileStatus(Status.DECLINED);
  }

  private async saveProfileStatus(status: Status): Promise<void> {
    this.error = '';
    this.loading = true;
    try {
      const vehicle = this.vehicle!;
      await this.utils.actionsToPromise(
        UserActions.setUserVehicleStatus({ vehicle, status }),
        UserActions.setUserVehicleStatusSuccess,
        UserActions.setUserVehicleStatusFailed
      );
    } catch (err: any) {
      this.error = this.utils.getErrorMessage(err);
    }
    this.loading = false;
  }
}
